var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditMealIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-2-icon",
    clipPath: "url(#clip0_6309_1309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.17467 5.65022L8.34983 4.82538L2.91667 10.2586V11.0834H3.7415L9.17467 5.65022ZM9.9995 4.82538L10.8243 4.00055L9.9995 3.17572L9.17467 4.00055L9.9995 4.82538ZM4.2245 12.2501H1.75V9.77497L9.58708 1.93788C9.69647 1.82852 9.84482 1.76709 9.9995 1.76709C10.1542 1.76709 10.3025 1.82852 10.4119 1.93788L12.0622 3.58813C12.1715 3.69752 12.233 3.84587 12.233 4.00055C12.233 4.15523 12.1715 4.30357 12.0622 4.41297L4.2245 12.2501Z",
    fill: "#858585"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6309_1309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMealIcon);
export default __webpack_public_path__ + "static/media/edit-meal-icon.b6387cbab1317b2230ae249c54481d04.svg";
export { ForwardRef as ReactComponent };